import { Logger } from 'Helpers/Logger'
import customerService from 'Services/customerService'
import tradegridPlusService from 'Services/tradegridPlusService'
import { FC, useState } from 'react'
import { useForm } from 'react-hook-form'
import './ReferAndEarn.scss'
import Swal from 'sweetalert2'

interface createReferalFormType {
  referralName: string
  businessName: string
  phoneNumber: string
  customerMsisdn: string
}

const CreateReferral: FC<{ closeModal: () => void }> = ({ closeModal }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<createReferalFormType>()

  const [request, setRequest] = useState(false)

  const submit = async (data: createReferalFormType) => {
    setRequest(true)
    await tradegridPlusService.createReferal(data).then(
      () => {
        closeModal()
        setRequest(false)
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Added Successfully',
          showConfirmButton: false,
          timer: 2000,
        })
      },
      (error) => {
        setRequest(false)
        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  const [msisdnErrors, setMsisdnErrors] = useState<boolean>()
  const [msisdnDetails, setMsisdnDetails] = useState<{ firstName: string; lastName: string }>()

  const verifyMsisdn = async (e: { target: { value: string } }): Promise<void> => {
    const msisdn: string = e.target.value
    setMsisdnDetails(undefined)
    const endpoint = `customerMsisdn=${encodeURIComponent(msisdn)}`
    if (msisdn.length >= 10 && msisdn.length <= 15) {
      await customerService.searchCustomer(endpoint, 1, 'DESC').then(
        (response) => {
          setMsisdnDetails({
            firstName: response.data.data.dataset[0].firstName,
            lastName: response.data.data.dataset[0].lastName,
          })

          setMsisdnErrors(false)
        },
        (error: { response: { data: { error: string } } }) => {
          setMsisdnErrors(true)
          Logger(error.response)
        },
      )
    }
  }

  return (
    <form onSubmit={handleSubmit((data) => submit(data))} className='createReferral'>
      <div className='form-group mb-3'>
        <label htmlFor='msisdn'>Customer msisdn</label>
        <input
          type='text'
          id='msisdn'
          className={errors.customerMsisdn ? 'form-control is-invalid' : 'form-control'}
          {...register('customerMsisdn', {
            onChange: (e: { target: { value: string } }) => {
              verifyMsisdn(e)
            },
          })}
        />
        {errors.customerMsisdn && (
          <div className='error text-danger'>{errors.customerMsisdn.message}</div>
        )}
        {msisdnErrors && <div className='error text-danger'>Phone number does not exist</div>}
        {msisdnDetails && (
          <small className='error text-success fw-bolder'>
            {msisdnDetails.firstName} {msisdnDetails.lastName}
          </small>
        )}
      </div>

      <div className='form-input mt-3'>
        <label htmlFor=''>Business name </label>
        <input
          type='text'
          {...register('businessName', {
            required: 'field is required',
          })}
          className='form-control'
        />
        {errors.businessName && <div className='error'>{errors.businessName.message}</div>}
      </div>
      <div className='form-input mt-3'>
        <label htmlFor=''>Name</label>
        <input
          type='text'
          {...register('referralName', {
            required: 'field is required',
          })}
          className='form-control'
        />
        {errors.referralName && <div className='error'>{errors.referralName.message}</div>}
      </div>
      <div className='form-input mt-3'>
        <label htmlFor=''>Phone number</label>
        <input
          type='text'
          {...register('phoneNumber', {
            required: 'field is required',
          })}
          className='form-control'
        />
        {errors.phoneNumber && <div className='error'>{errors.phoneNumber.message}</div>}
      </div>

      <button type='submit' className='btn btn-primary btn-refer' disabled={request}>
        Create Referal {request && <span className='spinner-border spinner-border-sm'></span>}
      </button>
    </form>
  )
}

export default CreateReferral
